import { httpService } from '../..';
import { IEntityWithMessages } from '../../services/HttpService';
import { IApiExecuteRespone } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { IBigCommerceShipTypeMap, IBigCommerceStore } from './bigCommerceInterfaces';

export async function fetchBigCommerceStores(): Promise<IApiExecuteRespone<IBigCommerceStore[]>> {
  const response: IApiExecuteRespone<IBigCommerceStore[]> = { requestFailed: false };

  try {
    const apiResponse = await httpService.get(ApiUrls.bigCommerceStore());
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function updateBigCommerceStore(
  store: IBigCommerceStore
): Promise<IApiExecuteRespone<IEntityWithMessages<IBigCommerceStore>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<IBigCommerceStore>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.bigCommerceStore(), store);
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function deleteBigCommerceStore(bigCommerceStoreId: number): Promise<IApiExecuteRespone<number>> {
  const response: IApiExecuteRespone<number> = { requestFailed: false };

  try {
    await httpService.delete(ApiUrls.bigCommerceStore(bigCommerceStoreId));
    response.value = bigCommerceStoreId;
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function fetchBigCommerceShipMethods(): Promise<IApiExecuteRespone<IBigCommerceShipTypeMap[]>> {
  const response: IApiExecuteRespone<IBigCommerceShipTypeMap[]> = { requestFailed: false };

  try {
    const apiResponse = await httpService.get(ApiUrls.bigCommerceShipMethod());
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function updateBigCommerceShipMethod(
  shipMethod: IBigCommerceShipTypeMap
): Promise<IApiExecuteRespone<IEntityWithMessages<IBigCommerceShipTypeMap>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<IBigCommerceShipTypeMap>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.bigCommerceShipMethod(), shipMethod);
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function deleteBigCommerceShipMethod(shipMethodId: number): Promise<IApiExecuteRespone<number>> {
  const response: IApiExecuteRespone<number> = { requestFailed: false };

  try {
    await httpService.delete(ApiUrls.bigCommerceShipMethod(shipMethodId));
    response.value = shipMethodId;
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}
